import { getSafePropertyChain } from '@empathy/get-safe-property-chain';
import { Result } from '@empathy/search-types';
import { StorageService } from '@empathy/storage-service';
import { container } from '../../../container';
import { DEPENDENCIES, STORAGE } from '../../../container/dependencies.const';
import { EmpathyXConfig } from '../../../models';
import { GETTERS_KEYS } from '../../store.const';
import { TRACKING_ACTIONS_KEYS } from '../tracking.const';
import { TrackingAction, TrackingContext } from '../tracking.interfaces';

export class SaveResultIdToLocalStorageAction implements TrackingAction {

  actions = {
    [TRACKING_ACTIONS_KEYS.saveResultIdToLocalStorage]: ({ rootGetters }: TrackingContext, result: Result) => {
      const storageService = container.getNamed<StorageService>(DEPENDENCIES.StorageService, STORAGE.Local);
      const { tracking }: EmpathyXConfig = rootGetters[GETTERS_KEYS.config.config];
      const storageKey = getSafePropertyChain(result, tracking.addToCart.storage.resultKeyField);
      storageService.setItem(tracking.addToCart.storage.rightClickResultId, storageKey, tracking.addToCart.storage.resultTTLInMs);
    }
  };
}
